const fontSizeMap = {
  microSmall: 4,
  verySmall: 6,
  extraSmall: 8,
  small: 10,
  normal: 12,
  large: 16,
  extraLarge: 20,
};

// KhatFlab1 renders visually larger than other families at the same size,
// so fixed font sizes are trimmed down whenever it's the active family.
const REDUCED_SIZE_FONT_FAMILY = "KhatFlab1";
const REDUCED_SIZE_AMOUNT = 2;

const getAdjustedFontSize = (size, family) => {
  const numericSize = typeof size === "string" ? parseFloat(size) : size;
  if (Number.isNaN(numericSize)) return size;

  const adjustedSize =
    family === REDUCED_SIZE_FONT_FAMILY
      ? Math.max(numericSize - REDUCED_SIZE_AMOUNT, 1)
      : numericSize;

  return typeof size === "string" && size.trim().endsWith("px")
    ? `${adjustedSize}px`
    : adjustedSize;
};

const getFontFamily = (styles, key, language = "en") => {
  const { family, familyAr } = styles?.[key] || {};
  return language === "ar" ? familyAr || family : family;
};

const getPublicSymbolSize = (size) => {
  switch (size) {
    case "verySmall":
      return { width: 5, height: "auto" };
    case "microSmall":
      return { width: 4, height: "auto" };
    case "extraSmall":
      return { width: 6, height: "auto" };
    case "small":
      return { width: 7, height: "auto" };
    case "normal":
      return { width: 8, height: "auto" };
    case "large":
      return { width: 10, height: "auto" };
    case "extraLarge":
      return { width: 12, height: "auto" };
    default:
      return { width: 12, height: "auto" }; // fallback
  }
};

const getStyle = (styles, key) => {
  if (!styles || !styles[key]) return {};

  const { size, color, family } = styles[key];

  return {
    ...(size && fontSizeMap[size]
      ? { fontSize: getAdjustedFontSize(fontSizeMap[size], family) }
      : {}),
    ...(color ? { color } : {}),
    ...(family ? { fontFamily: family } : {}),
  };
};

const getHarvestStyle = (styles, key, language) => {
  if (!styles || !styles[key]) return {};

  const { size, color, family, familyAr } = styles[key];
  const resolvedFamily = language === "ar" ? familyAr || family : family;

  return {
    ...(size && fontSizeMap[size]
      ? { fontSize: getAdjustedFontSize(fontSizeMap[size], resolvedFamily) }
      : {}),
    ...(color ? { color } : {}),
    ...(family ? { fontFamily: resolvedFamily } : {}),
  };
};

export const getThemeFontStyles = (theme = {}, language = "en") => {
  const {
    fontStyle: {
      family = "",
      sameFamilyOnBoth,
      familyAr,
      size = "normal",
      primaryColor = "#000000",
    } = {},
  } = theme;

  const resolvedFamily =
    language === "ar" && !sameFamilyOnBoth ? familyAr : family;

  return {
    fontFamily: resolvedFamily,
    fontSize: getAdjustedFontSize(
      fontSizeMap[size] || fontSizeMap.normal,
      resolvedFamily
    ),
    color: primaryColor,
  };
};

export const getHeaderStyles = (headerStyle = {}, primaryColor) => {
  const { family = "", size = "normal", color = "#000000" } = headerStyle;

  return {
    fontFamily: family,
    fontSize: getAdjustedFontSize(fontSizeMap[size] || fontSizeMap.normal, family),
    color: color || primaryColor,
  };
};

const getVisibilityStyle = (condition) => ({
  visibility: condition ? "visible" : "hidden",
});

export {
  getStyle,
  getVisibilityStyle,
  getHarvestStyle,
  getPublicSymbolSize,
  getAdjustedFontSize,
  getFontFamily,
};
